// @flow
// $FlowFixMe
import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { QUERIES } from "@/enums/queries";
import { globalQueryClient } from "queries/queryClient";
import type { ExportFileResponse, ExportParams } from "types/exports";

import { getExportFiles } from "./services/loadExportFiles";

export const useLoadExportFiles = (
  export_id: string,
  params: ExportParams,
  options: any = {},
  // $FlowFixMe
): UseQueryResult<ExportFileResponse, Error> => {
  return useQuery({
    queryKey: [QUERIES.EXPORT_FILES.LIST, export_id, params],
    queryFn: ({ signal }) => {
      return getExportFiles(export_id, params, { signal });
    },
    ...options,
  });
};

export const invalidateLoadExportFiles = () => {
  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.EXPORT_FILES.LIST],
    exact: false,
  });
};
